var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-patients.a0ec2b3b.png","uri@2x": __webpack_public_path__ + "icon-patients.4ca01e83.png","uri@3x": __webpack_public_path__ + "icon-patients.7102b550.png",
    width: 20,
    height: 20
});